export enum Resolution {
    p2160 = '2160p',
    p1920 = '1920p',
    p1440 = '1440p',
    p1080 = '1080p',
    p960 = '960p',
    p720 = '720p',
    p480 = '480p',
    p240 = '240p',
    p144 = '144p',
}

export enum Orientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}
